import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Import axios configuration to set up global interceptors
import './services/axiosConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
